module.exports = __webpack_public_path__ + "static/media/Antonios.1a7d4218.jpg";